import { yupResolver } from "@hookform/resolvers/yup"
import React from "react"
import { useForm } from "react-hook-form"
import Modal from "../../components/modal"
import * as Yup from "yup"
import { FormInput } from "../../wrappers/formInput"
import Button from "../../components/button"
import FormHead from "../../components/headings/FromHead"

export type AddProjectForm = {
  projectName: string
  reportingManagerName: string
  reportingManagerEmail: string
}

interface Props {
  onClose?: any
  ClickHandler?: any
  defaultValues?: any
}

const validationSchema = Yup.object({
  projectName: Yup.string().required("Field is Required"),
  reportingManagerName: Yup.string().required("Field is Required"),
  reportingManagerEmail: Yup.string().required("Field is Required"),
})

const AddProject: React.FC<Props> = ({ onClose, ClickHandler, defaultValues }) => {

  const formOptions = { resolver: yupResolver(validationSchema)}

  const { register, handleSubmit, formState } = useForm<AddProjectForm>(formOptions)

  const { v4: uuidv4 } = require("uuid")
 

  const onSubmit = (data: any) => {
    let body = {
      "projectId":  uuidv4(),
      "projectName": data.projectName,
      "reportingManagerName": data.reportingManagerName,
      "reportingManagerEmail": data.reportingManagerEmail,
    }
    ClickHandler(body)
  }

  return (
    <div>
      <Modal title={"Add User "} size="medium" onClose={onClose}>
        <form>
          <FormHead>Add Project</FormHead>
          <div className="half-form-wrap">
            <div className="form-group">
              <FormInput<AddProjectForm >
                name="projectName"
                register={register}
                errors={formState.errors}
                label="Project*"
                placeholder="Project Name"
              />
            </div>
            <div className="form-group">
              <FormInput<AddProjectForm>
                name="reportingManagerName"
                register={register}
                errors={formState.errors}
                label="Reporting manager name*"
                placeholder="Enter reporting manager name"
              />
            </div>
          </div>
          <div className="half-form-wrap">
            <div className="form-group">
              <FormInput<AddProjectForm>
                name="reportingManagerEmail"
                register={register}
                errors={formState.errors}
                label="Reporting manager email*"
                placeholder="Enter reporting manager email"
              />
            </div>
          </div>
          <div className="popupAction">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={handleSubmit(onSubmit)}>Save</Button>
          </div>
        </form>
      </Modal>
    </div>
  )
}
export default  AddProject
